<template>
  <div class="container">
    <div class="lang" @click="setLang">
      <mt-button icon="back" slot="left" @click="onGoHome"></mt-button>
      <img src="../../../assets/image/lang.png"/>
    </div>

    <div class="logo" @click="onGoHome">
      <img src="../../../assets/image/logo.png" alt="logo">
    </div>
    <div class="main-content">
      <div class="topList">
        <div class="list" style="position: relative;">
          <div class="item" v-for="(item, index) in items" :key="index" v-on:click="onClickItem(index)" v-bind:class="{
            active: index === currentIndex,
            // normal: index !== currentIndex
          }">
            <label class="title">{{ getTitle(item) }}</label>
          </div>
          <div class="contact-us" @click="onGoContactUs">{{$t('Contact us')}}>></div>
        </div>
      </div>
      <div class="login_form">
        <div class="top-wrapper">
          <flex-line class="input-wrapper">
            <span class="field-name">
              {{ $t("Username / Email / Phone Number") }}
            </span>
            <div class="field-line-right" slot="right">
              <input v-model="username" :placeholder="$t('Please enter')" type="text" />
            </div>
          </flex-line>

          <flex-line class="input-wrapper" :showPassword="showPassword" :toggleVisibility="toggleVisibility"
            :isPassword="true">
            <span class="field-name">
              {{ $t("Enter Password") }}
            </span>
            <div class="field-line-right" slot="right">
              <input class="field-input" :type="showPassword ? 'text' : 'password'" v-model="password"
                :placeholder="$t('Please enter')" />
            </div>
          </flex-line>

          <flex-line class="input-wrapper">
            <span class="field-name">
              {{ $t('Verification Code') }}
            </span>
            <div class="field-line-right captcha" slot="right">
              <input class="field-input" type="text" v-model="captcha" :placeholder="$t('Please enter')" />
              <img v-if="captcha_img" :src="captcha_img" alt="captcha_img" @click="makecode_">
            </div>
          </flex-line>
        </div>

        <div class="retrieve-wrapper" v-if="currentIndex == 0">
          <span class="retrieve-item" @click="onRetrieve">{{ $t("Forgot Password") }}?</span>
          <span class="retrieve-item" @click="onSignup">{{
            $t("Sign Up")
          }}</span>
        </div>
        <div style="display:flex;justify-content: space-between;" v-if="currentIndex == 0">
          <div class="common-btn ds-button-large" @click="signin">
            {{ $t("Login") }}
          </div>
          <div class="common-btn guest-login ds-button-large" @click="guestLogin">
            Guest Login
          </div>
        </div>
        <div style="margin: 30px auto;width:80%;" class="common-btn ds-button-large" @click="signin" v-else>
          {{ $t("Login") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  login,
  agent_login,
  wechatLogin,
  LoginByMobile,
  makecode
} from "../../../api/memberLogin"; 
import { auto_register } from "../../../api/memberRegister";
import { change_lang } from "../../../api/homeindex";
import { loadScript } from "../../../util/common";
import { getSmsCaptcha, checkPictureCaptcha } from "../../../api/common";
import { Indicator, Toast } from "mint-ui";
import { mapMutations, mapActions, mapState } from "vuex";
import flexLine from "../../flexLine";
export default {
  name: "Login",
  data() {
    return {
      ifLoaded: false,
      uniapp: 0,
      code: "",
      verifyCodeMobile: "",
      canSendMobile: true,
      timeIntervalMobile: false,
      sendStateTextMobile: this.$t("send"),
      mobileusername: "",
      username: "",
      password: "",
      currentIndex: 0,
      items: [
        {
          id: 1,
          title: "Login",
        },
        // {
        //   id: 2,
        //   title: "agent_login",
        // },
      ],
      password: "",
      captcha: '',
      showPassword: false,
      captcha_name: '',
      captcha_img: '',
    };
  },
  components: { flexLine },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      vm.utils.setCookie("referrer", encodeURIComponent(from.fullPath), 1 / 24);
    });
  },
  computed: {
    ...mapState({
      inviter_id: (state) => state.member.inviterId,
      config: (state) => state.config.config,
    }),
  },
  watch: {
    mobileusername(newVal, oldVal) {
      newVal = newVal.replace(/[^\d]/g, "");
      if (!newVal) {
        this.$nextTick(() => {
          this.mobileusername = newVal;
        });
      }
    },
    ifLoaded(newVal, oldVal) {
      if (newVal) {
        let _this = this;
        uni.getEnv(function (res) {
          if (res.plus) {
            _this.uniapp = 1;
          }
        });
      }
    },
  },
  beforeDestroy: function () {
    clearInterval(this.timeIntervalMobile);
  },
  created: function () {
    // const script = document.createElement('script')
    // script.src = ''
    // script.async = true
    // document.body.appendChild(script)
    this.utils.preloadImages([
      'https://file.goshop.shop/static/box/1.gif',
      'https://file.goshop.shop/static/box/2.gif'
    ]);
    let _this = this;
    loadScript(
      "uniapp",
      "https://js.cdn.aliyun.dcloud.net.cn/dev/uni-app/uni.webview.1.5.2.js",
      function () {
        _this.ifLoaded = true;
      }
    );
    Indicator.close();
    if (this.$route.query.clear) {
      this.memberLogout();
    }
    this.fetchConfig({}).then(
      (res) => {
        var config = res.result.config_list;
        if (config.sms_login == 1) {
          this.items.push({ id: 2, title: "phone login" });
        }
      },
      (error) => {
        Toast(error.message);
      }
    );
  },
  mounted() {
    const savedUsername = localStorage.getItem('lastUsername');
    if (savedUsername) this.username = savedUsername;
    this.makecode_()
    let isTokenInvalid = this.$route.params.isTokenInvalid;
    if (isTokenInvalid) {
      Toast(this.$t("Login Expired"));
    }
  },
  methods: {
    ...mapMutations({
      saveAuthInfo: "memberLogin",
      saveSellerAuthInfo: "sellerLogin",
      memberLogout: "memberLogout",
    }),
    ...mapActions({
      fetchConfig: "fetchConfig",
    }),
    makecode_() {
      makecode().then(res => {
        if (res.code == 10000) {
          this.captcha_name = res.result.captcha_name
          this.captcha_img = res.result.img
        }
      })
    },
    setLang() {
      // this.popupVisible = true;
      this.$router.push({ name: "HomeLang" });
    },
    toggleVisibility() {
      this.showPassword = !this.showPassword;
    },
    sendVerifyCodeMobile() {
      if (!this.mobileusername) {
        Toast(this.$t("Please enter your phone number first"));
        return;
      }
      if (!this.canSendMobile) {
        return;
      }
      getSmsCaptcha(2, this.mobileusername)
        .then((res) => {
          this.canSendMobile = false;
          let second = 60;
          Toast(res.message);
          let _this = this;
          this.timeIntervalMobile = setInterval(function () {
            if (second <= 0) {
              _this.canSendMobile = true;
              _this.sendStateTextMobile = _this.$t("send");
              clearInterval(_this.timeIntervalMobile);
            } else {
              _this.sendStateTextMobile = second + "s";
            }
            second--;
          }, 1000);
        })
        .catch(function (error) {
          Toast(error.message);
        });
    },
    getTitle(item) {
      return item ? this.$t(item.title) : "";
    },
    isShowLine(index) {
      return index === this.currentIndex;
    },
    onClickItem(index) {
      if (this.currentIndex !== index) {
        this.currentIndex = index;
      }
    },
    change_lang() {
      let lang = this.utils.fetch("lang");
      change_lang(lang);
    },
    //游客登录
    guestLogin(){
      window.location.href = 'https://www.trygobuy.com/member/index'
    },
    signin() {
      if (this.currentIndex == 0 || this.currentIndex == 1) {
        let username = this.username
        let password = this.password
        let captcha = this.captcha
        let captcha_name = this.captcha_name

        if (username.length === 0) {
          Toast(this.$t('Please enter your username/email/phone number'))
          return
        }
        // TODO: Validate username (which should be a phone number or email)
        if (password.length === 0) {
          Toast(this.$t('Please enter your password'))
          return
        }
        if (password.length < 6) {
          Toast(this.$t('Password must be at least 6 characters'))
          return
        }
        if (captcha.length === 0) {
          Toast(this.$t('Please enter the verification code'))
          return
        }
        Indicator.open()
        if (this.currentIndex == 0) {
          login(username, password, captcha, captcha_name).then(
            response => {
              Indicator.close()
              if (response.code == 10000) {
                this.saveAuthInfo({ token: response.result.token, info: response.result.info })
                // 登录同步语言设置
                this.change_lang()
                if (response.result.seller_info) {
                  this.saveSellerAuthInfo({ token: response.result.seller_token, info: response.result.seller_info })
                }
                localStorage.setItem('lastUsername', username);
                this.goHome()
                localStorage.setItem('all_usd_list','')
                localStorage.setItem('usd_list','')
              } else {
                this.makecode_()
                Toast(response.message)
              }
            },error => {
              this.makecode_()
              Indicator.close()
              Toast(error.message)
            }
          )
        } else {
          agent_login(username, password, captcha, captcha_name).then(
            response => {
              Indicator.close()
              if (response.code == 10000) {
                window.localStorage.setItem('agent_token', response.result.token)
                this.goHome()
              } else {
                Toast(response.message)
              }
            },
            error => {
              Indicator.close()
              Toast(error.message)
            }
          )
        }
      } else {
        let mobileusername = this.mobileusername
        if (mobileusername.length != 11) {
          Toast(this.$t('Please enter an 11-digit phone number'))
          return
        }
        Indicator.open()
        LoginByMobile(mobileusername, this.code).then(
          response => {
            Indicator.close()
            this.saveAuthInfo({ token: response.result.token, info: response.result.info })
            if (response.result.seller_info) {
              this.saveSellerAuthInfo({ token: response.result.seller_token, info: response.result.seller_info })
            }
            this.goHome()
          },
          error => {
            Indicator.close()
            Toast(error.message)
          }
        )
      }
    },
    goBack() {
      let isFromInfoEdit = this.$route.params.isFromInfoEdit;
      let isFromShare = this.$route.params.isFromShare;
      if (isFromInfoEdit || isFromShare) {
        this.$router.push("home");
      } else {
        this.$router.go(this.$route.query.clear ? -2 : -1);
      }
    },
    goHome() {
      let referrer = this.getReferrer();
      if (referrer) {
        // 返回之前的页面
        referrer = decodeURIComponent(referrer);
        this.utils.clearCookie("referrer");
        this.$router.replace({ path: referrer });
      } else {
        if (this.currentIndex == 0) {
          this.$router.replace({ name: "MemberIndex" });
        } else {
          this.$router.replace({ name: "AgentIndex" });
        }
      }
    },
    getReferrer() {
      let referrer = this.$route.query.referrer;
      if (!referrer) {
        referrer = this.utils.getCookie("referrer");
      }
      if (
        referrer &&
        (referrer.search("memberlogin") != -1 ||
          referrer.search("memberregister") != -1 ||
          referrer.search("memberbind") != -1)
      ) {
        referrer = "/member/index";
      }
      return referrer;
    },
    onGoContactUs() {
      this.$router.push({ name: "MemberContactUs" });
    },
    onGoHome(){
      this.$router.push({ name: "HomeIndex" });
    },
    onSignup() {
      this.$router.push({ name: "HomeMemberRegister" });
    },
    onRetrieve() {
      this.$router.push({ name: "HomeMemberForget" });
    },
    onWechat() {
      if (!this.ifLoaded) {
        Toast(this.$t("Please wait for the file to finish loading"));
        return;
      }
      let referrer = this.getReferrer();
      if (referrer) {
        // 返回之前的页面
        referrer = decodeURIComponent(referrer);
      }
      if (this.uniapp) {
        uni.redirectTo({
          url:
            "login?inviter_id=" +
            this.inviter_id +
            "&ret_url=" +
            encodeURIComponent(referrer),
        });
        return;
      }
      let ref = encodeURIComponent(referrer);
      wechatLogin(ref, this.inviter_id)
        .then((res) => {
          window.location.href = res.result;
        })
        .catch(function (error) {
          Toast(error.message);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.guest-login {
  background: unset !important;
  border: 1px #E7010C solid;
  color: #E7010C;
}
.contact-us{
  font-size: 14px;
  color: #eb1f11;
  position: absolute;
  right: 10px;
  bottom: -30px;
}
.bottom-btn {
  width: 100%;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.4rem;
  box-sizing: border-box;

  .retrieve-item {
    font-size: 1.4rem;
    font-weight: 600;
  }
}

.ds-button-large {
  width: 46%;
  margin-top: 10px;
  background: linear-gradient(90deg, #e8090c 0%, #f3611e 100%);
  padding: 0.2rem;
}

.lang {
  position: fixed;
  top: 15px;
  width: 90%;
  right: 5%;
  z-index: 99;
  display: flex;
  justify-content: space-between;
  .mint-button{
    border: unset;
    background-color: unset;
    box-shadow: none;
    padding: 0;
  }
  img {
    width: 35px;
    height: 35px;
  }
}

.logo {
  padding: 0.5rem 0;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    display: block;
  }
}

.common-header {
  .btn {
    background: #000;
    color: #fff;
    box-shadow: 0px 2px 4px #d2d2d2;
  }
}

.container {
  min-height: 100vh;
  background-image: url("../../../assets/image/bgc2.png");
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 2rem;
  box-sizing: border-box;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;

  .main-content {
    padding: 0 9px 1rem 9px;
  }

  .countdown {
    min-width: 4rem;
  }

  .send-btn {
    border: 1px solid $primaryColor;
    color: $primaryColor;
    min-width: 2rem;
  }

  .login_form {
    padding: 28px 8px 40px 8px;
    border: 1px solid #f45c1d;
    border-radius: 9px;
  }

  .top-wrapper {
    .input-wrapper {
      display: flex;
      align-content: center;
      align-items: center;
      background: transparent;

      img {
        height: 1.75rem;
        width: auto;
        margin: 0;
        padding: 0;
      }

      input {
        flex: 1;
        font-size: $subFontSize;
        background: transparent;
      }
    }

    .input-wrapper {
      margin-top: 24px;
    }

    .input-wrapper {
      display: flex;
      flex-direction: row;
      align-content: flex-start;
      align-items: center;
      background: transparent;

      flex-direction: column;
      align-items: flex-start;

      .field-name {
        width: 100%;
        font-size: 15px;
        font-weight: bold;
      }

      .field-name:nth-child(2) {
        margin: 0.5rem 0;
      }

      input {
        box-sizing: border-box;
        flex: 1;
        font-size: $subFontSize;
        flex: 1;
        width: 100%;
        text-align: left;
        border: 1px solid #f3611e;
        border-radius: 50px;
        padding: 19px 28px;
        background: #fafafa;
      }

      .bottom-input {
        border-bottom-width: 0;
      }

      .field-line-right {
        padding: 0px 0px 0px 0px;
        width: 100%;
        position: relative;
      }

      ::v-deep(.right) {
        width: 100%;
        margin-top: 25px;
      }
    }
  }
}
.retrieve-wrapper {
  padding: 33px 8px 0px 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 13px;
  color: #666666;
  font-weight: 600;
}

.bottom-wrapper {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-end;
  align-items: stretch;
}

.auth-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 13rem;
}

.auth-title-wrapper {
  height: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 2rem;
  margin-top: 1rem;
}

.auth-title {
  color: $descTextColor;
  font-size: $subFontSize;
}

.auth-line {
  display: flex;
  flex: 1;
  height: 1px;
  margin-left: 0.8rem;
  margin-right: 0.8rem;
}

.auth-item {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.auth-item-icon {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background: #fff;
  font-size: 3rem;
  box-shadow: 0px 4px 4px #e0e0e0;
  display: flex;
  justify-content: center;
  align-items: center;

  .icon {
    width: 60%;
  }
}

.auth-item-title {
  margin-top: 0.6rem;
  color: $formInputColor;
}

.auth-bottom-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin-left: 0.75rem;
  margin-right: 0.75rem;
  margin-bottom: 1rem;
}

.topList {
  padding: 41px 0px 0px 0px;

  .list {
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-end;
  }

  .item {
    width: 107px;
    height: 38px;
    background: linear-gradient(90deg, #d6d6d6 0%, #ededed 100%);
    border-radius: 16px 16px 0px 0px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .item:nth-child(1) {
    margin-right: 13px;
  }

  .title {
    text-align: center;
    font-size: 15px;
    color: #000000;
  }

  .active {
    color: #ffffff;
    background: linear-gradient(90deg, #e8090c 0%, #f3611e 100%);
    border-radius: 16px 16px 0px 0px;

    .title {
      color: #ffffff;
    }
  }

  .normal {
    color: #404245;
  }
}

::v-deep .flex-line {
  .right {
    width: 0;
  }
}
.captcha img{
  position: absolute;
  top: 9px;
  right: 10px;
  border: 1px solid #f45c1da3;
  border-radius: 50px;
}
</style>
